<template>
  <div
    class="new-page-con"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255,255,255,0.7)"
  >
    <div class="layout_header">
      <Header> </Header>
    </div>
    <div
      class="dataServices-page deatCleaning-container"
      ref="deatCleaningContainer"
      v-show="!showDetailView"
    >
      <div class="deatCleaning-inner">
        <!-- 步骤 -->
        <div class="deatCleaning-steps">
          <div class="deatCleaning-steps-title">
            <div class="big-title">Data Cleaning Services</div>
            <div class="small-title">
              Please upload the data content that you need to clean
            </div>
          </div>
          <ul class="deatCleaning-steps-box">
            <!-- step 1 -->
            <li
              class="deatCleaning-steps-con active"
              :class="{ dragbg: isDragging }"
            >
              <div class="deatCleaning-steps-con-in">
                <div class="deatCleaning-steps-body">
                  <div class="steps-con-title">Setp 1</div>
                  <div class="steps-con-subtitle">
                    Upload your list of company names for data cleaning
                  </div>
                  <div class="steps-con-smalltitle">
                    Please click the icon below to upload your file. Our system
                    will promptly process it to complete the data cleaning
                    service for you.
                  </div>
                  <div class="dc-download-template-out flex_center_start">
                    <img
                      src="../../../assets/images/dc_download_temp.png"
                      alt=""
                    />
                    <span
                      class="dc-download-template"
                      @click="uploadTemplateDownload"
                      >Download Template</span
                    >
                  </div>
                </div>
                <div class="dc-upload-out">
                  <!-- 未上传 -->
                  <div class="dc-upload-start" v-show="!fileUploading">
                    <el-upload
                      class="dc-upload-uploader"
                      ref="dcUploadRef"
                      action=""
                      drag
                      :file-list="uploadfileList"
                      :on-change="handleChange"
                      :limit="1"
                      :show-file-list="false"
                      :before-upload="beforeUpload"
                      :http-request="(params) => fileUpload(params)"
                    >
                      <img
                        src="../../../assets/images/dc_upload.png"
                        alt=""
                        class="dc-upload-uploader-icon"
                      />
                      <div class="dc-upload-start-tip">
                        Select CSV/EXCEL file for upload.(Max 100 records)
                      </div>
                    </el-upload>
                    <el-button
                      type="primary"
                      class="deatCleaning-steps-btn upload-select-btn"
                      >Select flie</el-button
                    >
                  </div>
                  <!-- 上传中 -->
                  <div class="dc-upload-ing" v-show="fileUploading">
                    <div class="dc-upload-ing-inner">
                      <img
                        src="../../../assets/images/dc_uploadfile.png"
                        alt=""
                        class="dc-upload-ing-icon"
                      />

                      <div class="flex_between_box" style="flex: 1">
                        <div class="dc-upload-ing-file">
                          <div class="dc-file-ttile">
                            {{ uploadFileDetail.name }}
                          </div>
                          <div class="dc-file-memory">
                            {{ uploadFileDetail.size }}
                          </div>
                        </div>
                        <template v-if="fileUploadingAllow">
                          <div
                            class="dc-upload-ing-close"
                            v-if="operationAdjust"
                            style="cursor: not-allowed;opacity: 0.4;"
                          >
                            <i class="el-icon-close"></i>
                          </div>
                          <div
                            class="dc-upload-ing-close"
                            @click="reUploading"
                            v-else
                          >
                            <i class="el-icon-close"></i>
                          </div>
                        </template>
                        
                        <div
                          class="dataCleaning-spinner"
                          v-if="!fileUploadingAllow"
                        ></div>
                      </div>
                    </div>
                    <el-progress
                      v-if="fileUploadingAllow"
                      :percentage="fileUploadingCurrentPercent"
                      class="dc-upload-ing-progress"
                    ></el-progress>
                    <el-button
                      type="primary"
                      class="deatCleaning-steps-btn upload-select-btn"
                      @click="cancelUploading"
                      v-if="!fileUploadingSuccess"
                      >Cancel</el-button
                    >
                    <el-button
                      type="primary"
                      class="deatCleaning-steps-btn upload-select-btn"
                      @click="fileSelectedStep"
                      v-if="fileUploadingSuccess && step == 1"
                      >Next</el-button
                    >
                    <div v-if="fileUploadingSuccess && step > 1">
                      <el-button
                        type="primary"
                        class="deatCleaning-steps-btn upload-select-btn"
                        @click="reUploading"
                        :disabled="operationAdjust"
                        >Re-upload</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="deatCleaning-steps-arrow flex_center">
              <img
                src="../../../assets/images/dc_step_icon.png"
                alt=""
                v-if="step == 1"
              />
              <img
                src="../../../assets/images/dc_step_icon1.png"
                alt=""
                v-if="step > 1"
              />
            </li>
            <!-- step 2 -->
            <li class="deatCleaning-steps-con" :class="{ active: step > 1 }">
              <div class="deatCleaning-steps-con-in">
                <div class="deatCleaning-steps-body">
                  <div class="steps-con-title">Setp 2</div>
                  <div class="steps-con-subtitle">
                    Select your data requirements
                  </div>
                  <div class="steps-con-smalltitle">
                    Please choose your data cleaning requirements from the
                    options provided. Our system will then customize the
                    cleaning service to meet the specific needs of your uploaded
                    data.
                  </div>
                  <div class="steps-con-collapse">
                    <el-checkbox
                      :disabled="step == 1"
                      class="steps-con-collapse-checkbox"
                      :indeterminate="isIndeterminate"
                      v-model="checkAll"
                      @change="handleCheckAllChange"
                    >
                      Select All
                    </el-checkbox>
                    <el-checkbox-group
                      :disabled="step == 1"
                      v-model="step2checkList"
                      class="steps-con-collapse-checkbox"
                    >
                      <!-- <el-collapse> -->
                      <!-- <el-collapse-item title="Requirement 1：Remove duplicate data records" name="1"> -->
                      <el-checkbox
                        :label="item.fieldCode"
                        v-for="(item, index) in cleanFieldAllVisible"
                        :key="item.fieldCode + index"
                        :disabled="item.choiced == 1"
                        :checked="item.choiced == 1"
                        >{{ item.fieldNameDec }}</el-checkbox
                      >

                      <!-- </el-collapse-item> -->

                      <!-- </el-collapse> -->
                    </el-checkbox-group>
                  </div>
                </div>
                <div class="deatCleaning-steps-footer flex_center_bettwen">
                  <el-button
                    :disabled="step < 2 || step2checkList.length == 0"
                    class="deatCleaning-steps-btn"
                    @click="step2Reselect"
                    >Reselect</el-button
                  >
                  <el-button
                    type="primary"
                    :disabled="step < 2 || step2checkList.length == 0"
                    class="deatCleaning-steps-btn"
                    @click="dataCleaningStep"
                    >Data Cleaning</el-button
                  >
                </div>
              </div>
            </li>
            <li class="deatCleaning-steps-arrow flex_center">
              <img
                src="../../../assets/images/dc_step_icon.png"
                alt=""
                v-if="step < 3"
              />
              <img
                src="../../../assets/images/dc_step_icon1.png"
                alt=""
                v-if="step > 2"
              />
            </li>
            <!-- step 3 -->
            <li class="deatCleaning-steps-con" :class="{ active: step == 3 }">
              <div class="deatCleaning-steps-con-in">
                <div class="deatCleaning-steps-body">
                  <div class="steps-con-title">Setp 3</div>
                  <div class="steps-con-subtitle">
                    Cleaning Complete & View Results
                  </div>
                  <div class="steps-con-smalltitle">
                    After the cleaning process is finished, you can view the
                    final results, including the DQI and the time when the data
                    was updated, in the Result Data table.
                  </div>
                  <!-- 进度 -->
                  <div
                    class="dc-cleaning-ing-box"
                    v-if="uploadProgressRes.batchId"
                  >
                    <div class="dc-cleaning-ing-title">
                      <div class="cleaning-ing-label">Task ID： </div>
                      <div class="cleaning-ing-ellipsis">
                        {{ uploadProgressRes.batchId }}
                      </div>
                    </div>
                    <div class="dc-cleaning-ing-smtitle">
                      <div class="cleaning-ing-smtitle-fixed">File：</div>
                      <div class="cleaning-ing-smtitle-ellipsis">
                        {{ uploadProgressRes.fileName }}
                      </div>
                    </div>
                    <div
                      class="dc-cleaning-ing-timing"
                      v-if="uploadProgressRes.remainTime != '0s'"
                    >
                      <i class="el-icon-time"></i>
                      Estimated remaining time:
                      {{ uploadProgressRes.remainTime }}
                    </div>
                    <el-progress
                      :percentage="uploadProgressComputed"
                      class="dc-upload-ing-progress"
                      :show-text="false"
                    ></el-progress>
                    <div
                      class="dc-cleaning-ing-progress"
                      v-if="uploadProgressRes.remainTime == '0s'"
                    >
                      <div
                        class="point-taskStatus mini cleaningCompleted"
                      ></div>
                      Completed
                    </div>
                    <div class="dc-cleaning-ing-progress" v-else>
                      <div class="point-taskStatus mini regenerating"></div>
                      Cleaning in progress
                    </div>
                  </div>
                </div>
                <div
                  class="deatCleaning-steps-footer flex_center_end"
                  v-if="uploadProgressRes.batchId"
                >
                  <!-- <el-button
                    type="primary" 
                    class="deatCleaning-steps-btn"
                    >Back</el-button
                  > -->
                  <el-button
                    type="primary"
                    class="deatCleaning-steps-btn"
                    @click="toRegenerate"
                    >Regenerate</el-button
                  >
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- table -->
        <div class="deatCleaning-result">
          <div class="deatService-left-filter">
            <div class="deatService-left-filter-reset" @click="resetFilters">
              <i class="el-icon-refresh-left"></i>Reset
            </div>
            <div class="dataService-left-collapse">
              <div class="dataService-left-item">
                <div class="dataService-left-header">Task ID</div>
                <el-input
                  size="medium"
                  clearable
                  v-model="fileNameValue"
                  @keyup.enter.native="getFilesListFn"
                  placeholder="Select Task ID"
                >
                </el-input>
              </div>
              <div class="dataService-left-item">
                <div class="dataService-left-header">Cleaning Time</div>
                <el-date-picker
                  class="dc-cleaning-timepicker"
                  v-model="cleaningTimePicker"
                  @change="getFilesListFn"
                  range-separator=""
                  start-placeholder="Start date"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  end-placeholder="End date"
                ></el-date-picker>
              </div>
              <div class="dataService-left-item">
                <div class="dataService-left-header">Task Status</div>
                <el-select
                  size="medium"
                  clearable
                  @change="getFilesListFn"
                  v-model="taskStatusvalue"
                  placeholder="Select Task Status"
                >
                  <el-option
                    v-for="item in taskStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="dataService-left-item">
                <div class="dataService-left-header">Tag</div>
                <el-select
                  size="medium"
                  clearable
                  multiple 
                  @change="getFilesListFn"
                  v-model="taskTagvalue"
                  placeholder="Select Tag"
                >
                  <el-option
                    v-for="item in dcFiltersTags"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="deatCleaning-table-box">
            <div
              class="deatCleaning-table-summary flex_center_bettwen"
              ref="dataSummary"
            >
              <div class="summary-item">
                <div
                  class="summary-item-num"
                  :class="{ totalTasks: statisticsRes.completedFileCount }"
                >
                  {{ statisticsRes.totalFileCount }}
                </div>
                <div class="summary-item-title">Total Tasks</div>
              </div>
              <div class="summary-item">
                <div
                  class="summary-item-num"
                  :class="{
                    tasksin30Days: statisticsRes.recentThirtyDaysFileCount,
                  }"
                >
                  {{ statisticsRes.recentThirtyDaysFileCount }}
                </div>
                <div class="summary-item-title">Tasks in 30 Days</div>
              </div>
              <div class="summary-item">
                <div
                  class="summary-item-num"
                  :class="{ completedTasks: statisticsRes.completedFileCount }"
                >
                  {{ statisticsRes.completedFileCount }}
                </div>
                <div class="summary-item-title">Completed Tasks</div>
              </div>
              <div class="summary-item">
                <div
                  class="summary-item-num"
                  :class="{ successRate: statisticsRes.successRate }"
                >
                  {{ statisticsRes.successRate }}
                </div>
                <div class="summary-item-title">Success Rate</div>
              </div>
            </div>
            <div class="deatCleaning-table-in">
              <el-table
                ref="Usagelist"
                class="table_box table_height_30 table_font_size_14 custom-parent-table"
                @expand-change="handleExpandChange"
                :expand-row-keys="expandedRowKeys"
                :data="taskList"
                style="width: 100%"
                row-key="id"
              >
                <el-table-column 
                type="expand" 
                width="40"
                >
                  <template slot-scope="scope">
                    <SubTable
                      :scope-row="scope.row"
                      :currentParentIndex="scope.$index"
                      @toDetailViewFn="toDetailView"
                      @getChildrenDataFn="getChildrenData"
                      @updateParentChildDataFn="updateParentChildData"
                      @updateDataCleaning="updateDataCleaning"
                      @batchUpdateDataCleaning="batchUpdateDataCleaning"
                      @toDownloadSingleFn="exportExeclDownloadSingle"
                      @update-selection="
                        handleChildSelection($event, scope.row)
                      "
                    ></SubTable>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="fileName"
                  label="Task ID"
                  align="left"
                  min-width="200"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{ scope.row.fileName }}
                  </template>
                </el-table-column>

                <el-table-column
                  prop="taskStatus"
                  label="Task Status"
                  align="left"
                  width="200"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span
                      class="point-taskStatus"
                      :class="formatTaskStatusClass(scope.row.taskStatus)"
                    ></span>
                    <span>{{ formatTaskStatus(scope.row.taskStatus) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="results"
                  label="Results"
                  align="center"
                  width="200"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <div
                      class="dataCleaning-result-succeccFailed"
                      v-if="scope.row.totalAndSuccess"
                    >
                      <span class="res-success"
                        >Success:
                        {{ scope.row.totalAndSuccess.split("/")[0] }}</span
                      >
                      <span class="res-failed"
                        >Failed:
                        {{ getDifference(scope.row.totalAndSuccess) }}</span
                      >
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Tag"
                  align="left"
                  width="300"
                >
                  <template slot-scope="scope">
                    <div class="filter-tag-row">
                      <div class="filter-tag-list">
                        <template 
                        v-for="(tag, index) in scope.row.enumList">
                          <div 
                          :key="tag.id+'_'+index"
                          v-show="scope.row.editingTagId === tag.id"
                          >
                            <el-input
                              class="input-new-tag"
                              v-model="tag.enumValue"
                              :ref="'editInput_'+ tag.id"
                              :key="'edit_'+ tag.id"
                              size="small"
                              @blur="(e) => handleBlurEdit(scope.row, tag)"
                              @keyup.enter.native="(e) => handleBlurEdit(scope.row, tag)"
                            >
                            </el-input>
                          </div>
                          <el-tooltip 
                            :key="tag.id+'_tooltip_'+index"
                            v-show="scope.row.editingTagId !== tag.id"
                            effect="dark" 
                            :content="tag.enumValue" 
                            placement="top-start"
                          >
                            <el-tag
                              class="filter-tag"
                              closable
                              :disable-transitions="false"
                              @click.native="(e) => handleClickEdit(scope.row, tag)"
                              @close="handleFilterTagClose(tag.id)">
                              <div class="filter-tag-text">{{tag.enumValue}}</div>
                            </el-tag>
                          </el-tooltip>
                        </template>
                      </div>
                      <div class="filter-tag-btn" v-if="scope.row.enumList.length < 3">
                        <el-input
                          class="input-new-tag"
                          v-if="scope.row.inputVisible"
                          v-model="scope.row.inputValue"
                          :ref="'saveTagInput_'+scope.row.id"
                          size="small"
                          @keyup.enter.native="handleTagInputConfirm(scope.row)"
                          @blur="handleTagInputConfirm(scope.row)"
                        >
                        </el-input>
                        <el-button 
                        v-else
                        class="button-new-tag" 
                        size="small" @click="showInput(scope.row)"
                        >+ Add Tag</el-button>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                
                <el-table-column
                  prop="cleaningTime"
                  label="Cleaning Time"
                  align="right"
                  min-width="200"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{ formatCreateTime(scope.row.createTime) }}
                  </template>
                </el-table-column>

                <el-table-column
                  prop=""
                  label="Operations"
                  align="center"
                  width="300"
                >
                  <template slot-scope="scope">
                    <div class="flex_center dataClean-operate-box">
                      <el-button type="text"
                        class="dataClean-operate"
                        :disabled="!scope.row.allowDownload"
                        @click="toDownload(scope.row.batchId, scope.row.fileName)"
                      >
                        Download
                      </el-button>
                      <el-button type="text"
                        class="dataClean-operate"
                        @click="adjustDataCleaning(scope.row, scope.$index)"
                      >
                        Adjust
                      </el-button>
                      <!-- <div class="dataClean-operate"
                      @click="updateDataCleaning"
                      >Update</div>  -->
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div class="page_i_box dataService">
                <Page
                  :totalFont="true"
                  :total="page.total"
                  :pageSize.sync="page.pageSize"
                  :currentPage="page.pageNo"
                  @onPageChange="onPageChangeList"
                ></Page>

                <div class="search_rsult_txt line_2">
                  {{ page.pageNo }}-{{ page.pageSize }} of over
                  {{ page.total | FilterNum }} results for "Data Cleaning"
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- detail 弹框 -->
    <DetailView
      v-if="showDetailView"
      @showDetailViewBack="showDetailViewBack"
      :detailData="uploadCleaningResultList"
      :current="uploadCleaningResultListIndex"
      @toDownloadSingleFn="exportExeclDownloadSingle"
    ></DetailView>
    <!-- Update -->
    <UpdateDialog
      :dialogVisible="dialogVisibleUpdate"
      @closeDialogVisibleUpdate="closeDialogVisibleUpdate"
      :aaaid="aaaIdUpdate"
      :selectedCompanys="aaaIdCompanyUpdate"
      :type="updateDataCleaningType"
      :taskId="parentTaskId"
      @getChildrenDataFn="getChildrenData"
      @closeSelectfiledRefresh="closeSelectfiledRefresh"
    ></UpdateDialog>
    <!-- 扫描中动画 -->
    <el-dialog
      title=""
      class="dialog_550 dialog_modal"
      :visible.sync="loadingVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="dialog_content">
        <div class="dialog_title_tips">Data cleaning is in progress ...</div>
        <div class="loading_box">
          <div class="loading_bg"></div>
          <div class="loading_num">{{ uploadProgressComputed }}%</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      class="dialog_550 dialog_modal datacleaningFinal"
      :visible.sync="cleanOverVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="dialog_content">
        <img
          src="@/assets/images/dataServices/dataCleaning-img/cleaningover.png"
          alt=""
        />
        <div class="content-result-title">Data Clearning</div>
        <div class="content-result-detail">
          You have selected a total of
          <span class="txt-brown">{{ uploadProgressTotal }}</span> companies,
          among which
          <span class="txt-green">{{ uploadProgressRes.successCount }}</span>
          succeeded and
          <span class="txt-red">{{ uploadProgressRes.failedCount }}</span>
          failed. Please click [Confirm] to start data cleaning.
        </div>
      </div>
      <div class="datacleaning-tags">
        <div class="datacleaning-tags-title">You can add tags to this group of data for easier searching.</div>
        <div 
          v-for="(val, index) in dcTagInputList" 
          :key="'dctag'+index" 
          class="datacleaning-tags-wrapper"
        >
          <el-input
            v-model="dcTagInputList[index]"
            placeholder="Please enter 1-20 characters."
          >
            <!-- suffix 插槽：内部右侧图标 -->
            <i 
              slot="suffix" 
              class="action-icon"
              :class="getIconClass(index)" 
              @click="handleAction(index)"
            ></i>
          </el-input>
        </div>
      </div>

      <div class="dc-dialog-footer flex_center_bettwen">
        <el-button class="dc-cleaning-btn-reset" @click="cleanOverCancel"
          >Cancel
        </el-button>
        <el-button
          type="primary"
          class="dc-cleaning-btn"
          @click="cleanOverConfirm"
          >Confirm</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Header from "../../layout/header.vue";
import Page from "@/components/page/index.vue";
import DetailView from "./dataCleaningDetailView.vue";
import SubTable from "./dataCleaningSubtable.vue";
import UpdateDialog from "./dataCleaningUpdateDialog.vue";
import {
  dataCleaningUpload,
  findAllEnableFields,
  saveFiledsAndCleaning,
  getUploadProgress,
  getFilesList,
  getStatistics,
  getUploadedCompanies,
  regenerate,
  getUploadedCompaniesAgg,
  findListByBatchIdAndUserId,
  getUploadedCompaniesResult,
  insertEnum, updateEnum, deleteEnum, getAllEnum,
  downloadFileByIds, downloadFileByFileId
} from "@/api/dataServicesApi";
import { exportExcelJs } from "@/utils/excelJs";

export default {
  components: {
    Header,
    Page,
    DetailView,
    SubTable,
    UpdateDialog,
  },
  data() {
    return {
      step: 1,
      taskList: [],
      page: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      pageChildren: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      currentExpandedRow: null,
      expands: [],
      datePicker: [],
      cascInptComapny: "",
      cascInptIndustry: "",
      industryList: [],
      companyTypeCheckList: "",
      companyTypeList: [],
      companyStatusCheckList: "",
      companyStatusList: [],
      PortfolioList: [
        {
          id: 2,
          coName: "DC20260520001",
          country: "2026-05-20 10:00:00",
          regStatus: "Completed",
          legalForm: "1/50",
          regCapital: "",
        },
      ],
      isChangeProlio: true,
      checkList: [],
      // 选中的 fieldCode 数组（保持页面顺序！）
      step2checkList: [],
      // 全选状态
      checkAll: false,
      isIndeterminate: false,
      // 筛选
      filtersActiveNames: ["1", "2", "3", "4"],
      fileNameValue: null,
      cleaningTimePicker: [],
      taskStatusOptions: [
        {
          value: "0",
          label: "Unexecuted",
          class: "",
        },
        {
          value: "1",
          label: "Success",
          class: "completed",
        },
        {
          value: "5",
          label: "Failed",
          class: "cancelled",
        },
        {
          value: "6",
          label: "Processing",
          class: "Unexecuted",
        },
      ],
      taskStatusvalue: null,
      taskTagvalue: null,
      showDetailView: false,
      // 拖拽
      isDragging: false,
      dragCounter: 0, // 防止 dragleave 误触发
      cleanFieldAll: [], //清洗字段
      cleaningLoading: false, //开始清洗，加载
      uploadProgressRes: {
        fileName: "", //文件名
        batchId: "", //任务id
        progressRatio: "", //进度
        remainTime: "", //剩余时间
        successCount: "", //成功数量
        failedCount: "", //失败数量
      },
      statisticsRes: {
        completedFileCount: "", //完成任务数
        successRate: "", //成功率
        totalFileCount: "", //总任务数
        recentThirtyDaysFileCount: "", //一个月内任务数
      },
      uploadFileDetail: {
        name: "",
        size: 0,
      },
      uploadfileList: [],
      fileUploading: false,
      fileUploadingAllow: false, //校验格式做进度条，允许之后才可以
      fileUploadingCurrentPercent: 0, // 当前进度百分比 (0-100)
      fileUploadingTargetPercent: 100, // 目标进度
      progressTimer: null, // 定时器引用
      fileUploadingLoading: false,
      fileUploadingResult: {},
      fileUploadingSuccess: false,
      uploadDisabled: false, //正在清洗时不可再传
      allTimers: [],
      detailData: [],
      dialogVisibleUpdate: false,
      updateDataCleaningType: "",
      subtableCleanParent: {},
      aaaIdUpdate: [],// 接口改了，只需要数组
      aaaIdCompanyUpdate: [], //当前选择的公司，update需要用
      uploadCleaningResultList: [], //当前展开行的全部子数据，在View中点击Next Page使用
      uploadCleaningResultListIndex: 1,
      // 扫描进度
      loadingVisible: false,
      cleanOverVisible: false,
      // 初始化默认有一个输入框
      dcTagInputList: [''],
      dcFiltersTags: [],
      // 控制展开的行（存储 row-key 值）
      expandedRowKeys: [],
      parentTaskId: "",
      handleExpandRowIndex: null,//手动展开哪行
      operationAdjust: false,//点击 Adjust
    };
  },
  beforeUnmount() {
    // 移除监听器（避免内存泄漏）
    const uploadEl = this.$refs.uploadRef?.$el;
    if (uploadEl) {
      uploadEl.removeEventListener("dragenter", this.handleDragEnter);
      uploadEl.removeEventListener("dragover", this.handleDragOver);
      uploadEl.removeEventListener("dragleave", this.handleDragLeave);
      uploadEl.removeEventListener("drop", this.handleDrop);
    }
  },
  beforeDestroy() {
    // 清理动画
    if (this.progressTimer) {
      cancelAnimationFrame(this.progressTimer);
    }
    this.timer && clearInterval(this.timer);
  },
  computed: {
    uploadProgressTotal() {
      let successCount = this.uploadProgressRes.successCount || 0;
      let failedCount = this.uploadProgressRes.failedCount || 0;
      return Number(successCount) + Number(failedCount);
    },
    uploadProgressComputed() {
      // 移除 '%' 并转为数字
      return parseFloat(this.uploadProgressRes.progressRatio) || 0;
    },
    // 默认项只做传值，不在显示
    cleanFieldAllVisible() {
      return this.cleanFieldAll.filter((item) => item.choiced != 1);
    },
    defaultCheckedList() {
      let arr = this.cleanFieldAll
        .filter((x) => x.choiced == 1)
        .map((x) => x.fieldCode);
      return arr;
    },
  },
  filters: {},
  watch: {
    // 监听 step2checkList 变化，更新全选状态
    step2checkList(newVal) {
      const checkedCount = newVal.length;
      const totalCount = this.cleanFieldAllVisible.length;

      if (checkedCount === 0) {
        this.checkAll = false;
        this.isIndeterminate = false;
      } else if (checkedCount === totalCount) {
        this.checkAll = true;
        this.isIndeterminate = false;
      } else {
        this.checkAll = false;
        this.isIndeterminate = true;
      }
    },
  },
  mounted() {
    // 主题色
    this.$store.dispatch("app/setThemColor", "#B98B73");
    this.$store.dispatch("app/setSearchType", "dataServices");
    // 预加载所有可能用到的背景图
    this.preloadImages([
      require("@/assets/images/dc_step_active.png"),
      require("@/assets/images/dc_step_activebg.png"),
    ]);
    // 拖拽上传
    const uploadRef = this.$refs.dcUploadRef;
    console.log(uploadRef);
    if (uploadRef) {
      const uploadEl = uploadRef.$el;

      // 监听拖入
      uploadEl.addEventListener("dragenter", this.handleDragEnter);
      // 监听拖动经过（必须阻止默认，否则 drop 不生效）
      uploadEl.addEventListener("dragover", this.handleDragOver);
      // 监听拖出
      uploadEl.addEventListener("dragleave", this.handleDragLeave);
      // 监听释放
      uploadEl.addEventListener("drop", this.handleDrop);
    }
    // 获取清洗字段
    this.getFindAllEnableFields();
    this.getFilesListFn();
    this.getStatisticsFn();
    this.getAllEnumFn();
  },
  methods: {
    downloadDisabled(totalAndSuccess){
      if(!totalAndSuccess || totalAndSuccess.split('/')[0] == 0){
        return true
      }
      return false
    },
    async handleFilterTagClose(tagId) {
      let params = {
        id: tagId
      }
      await deleteEnum(params).then((res) => {
        console.log(res);
        if(res.code == 200){
          this.getFilesListFn();
          this.getAllEnumFn();
        }else {
          this.$message.error(res.msg);
        }
        
      });
    },
    showInput(row) {
      row.inputVisible = true;
      row.inputValue = '';
      this.$nextTick(() => {
        const inputRef = this.$refs['saveTagInput_'+row.id];
        console.log(inputRef);
        if (inputRef) {
          inputRef.focus();
        }
      });
    },
    // Add tag
    handleTagInputConfirm(row) {
      const val = row.inputValue.trim();
      if (val) {
        // 检查是否已存在同名标签（可选）
        const exists = row.enumList.some(t => t.enumValue === val);
        if (!exists) {
          let params = [{
            enumValue: val,
            batchId: row.batchId
          }]
          this.insertEnumFn(params, 'table');
        }
      }
      row.inputVisible = false;
      row.inputValue = '';
      
    },
    // edit tag
    // 2. 点击标签 -> 进入编辑模式
    handleClickEdit(row, tag) {
      // 设置当前行的编辑状态为该标签 ID
      tag._originalName = tag.enumValue; 
      row.editingTagId = tag.id;
      console.log(row);
      this.$nextTick(() => {
        const inputs = this.$refs['editInput_'+ tag.id];
        console.log(inputs);
        if (inputs && inputs.length > 0) {
          inputs[0].focus();
        }
      });
    },
    async handleBlurEdit(row, tag, event) {
      console.log(row, tag);
      const newValue = tag.enumValue.trim();
      const originalName = tag._originalName; // 获取备份值
      // --- 值没有变化 ---
      if (newValue === originalName) {        
        row.editingTagId = null;
        delete tag._originalName; 
        return; 
      }
      // 校验非空
      if (!newValue) {
        this.$message.warning('标签名不能为空');
        tag.enumValue = originalName; 
        row.editingTagId = null;
        delete tag._originalName;
        return;
      }
      let params = {
        id: tag.id,
        enumValue: newValue
      }
      await updateEnum(params).then((res) => {
        console.log(res);
        if(res.code == 200){
          // 保存成功，退出编辑模式
          delete tag._originalName;
          row.editingTagId = null;
          this.getFilesListFn();
          this.getAllEnumFn();
        }else {
          this.$message.error(res.msg);
        }
      });
      
      
    },
    // 弹框中标签
    getIconClass(index) {
      const isLast = index === this.dcTagInputList.length - 1;
      const isFull = this.dcTagInputList.length >= 3;

      if (isLast && !isFull) {
        return 'el-icon-plus';
      } else {
        return 'el-icon-close';
      }
    },
    /**
     * 处理点击
     */
    handleAction(index) {
      const isLast = index === this.dcTagInputList.length - 1;
      const isFull = this.dcTagInputList.length >= 3;
      const type = this.getIconClass(index);
      if (type === 'el-icon-plus') {
        // 新增：往数组推入一个空字符串
        this.dcTagInputList.push('');
      } else if (type === 'el-icon-close') {
        // 删除：如果只剩一个，提示；否则删除当前索引
        if (this.dcTagInputList.length <= 1) {
          this.$message.warning('至少保留一个输入框');
          return;
        }
        this.dcTagInputList.splice(index, 1);
      }
    },
    // step2 复选框
    // 全选 / 取消全选
    handleCheckAllChange(val) {
      this.step2checkList = val
        ? this.cleanFieldAllVisible.map((item) => item.fieldCode)
        : [];
      this.isIndeterminate = false;
    },
    preloadImages(imagePaths) {
      imagePaths.forEach((path) => {
        const img = new Image();
        img.src = path; // 触发浏览器缓存
      });
    },
    // 父级 table 下载
    async toDownload(batchId, fileName) {
      let params = {
        batchId
      };
      console.log('download参数', params);
      downloadFileByFileId(params).then((res) => {
        console.log('exportExcelData 结果', JSON.parse(JSON.stringify(res)));
        if (res) {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement("a");
          link.href = url;
          link.download = "download.zip";
          link.click();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    async toDownloadOld(batchId, fileName) {
      await getUploadedCompaniesResult(`?batchId=${batchId}`).then((res) => {
        console.log(res);
        this.exportExeclDownload(res.data, fileName);
      });
    },
    exportExeclDownload(data, fileName) {
      // ===第一步：生成 columns（合并字段 + Company Name 置顶）===
      let successCompanies = data.successCompanies;
      const fieldMap = new Map();
      for (const company of successCompanies) {
        for (const item of company.uploadDataCleaningResult) {
          if (item.fieldCode && item.fieldDec) {
            if (!fieldMap.has(item.fieldCode)) {
              fieldMap.set(item.fieldCode, {
                fieldCode: item.fieldCode,
                fieldDec: item.fieldDec,
              });
            }
          }
        }
      }
      let fields = Array.from(fieldMap.values());
      fields.sort((a, b) => {
        if (a.fieldDec === "Company Name") return -1;
        if (b.fieldDec === "Company Name") return 1;
        return 0;
      });
      const columnsSuccess = fields.map(({ fieldDec, fieldCode }) => ({
        header: fieldDec,
        key: fieldCode,
        width: 30,
      }));
      // ===第二步：生成 result（每条数据转成 { fieldCode: fieldValue }）====
      const resultSuccess = successCompanies.map((company) => {
        const obj = {};
        for (const item of company.uploadDataCleaningResult) {
          if (item.fieldCode !== undefined && item.fieldValue !== undefined) {
            obj[item.fieldCode] = item.fieldValue;
          }
        }
        return obj;
      });
      // ============失败单独写==================
      const columnsFailed = [
        { header: "Company Name", key: "companyName", width: 30 },
        { header: "Company Country", key: "countryCode", width: 30 },
        { header: "Reason", key: "taskStatusReason", width: 30 },
      ];
      let loopFailed = data.failureCompanies || [];
      let resultsFailed = [];
      for (const item of loopFailed) {
        resultsFailed.push({
          companyName: item.companyName,
          countryCode: item.countryCode,
          taskStatusReason: item.taskStatusReason,
        });
      }
      let excelName = fileName;
      let alldata = [
        {
          columns: columnsSuccess,
          results: resultSuccess,
          sheetName: "Success",
          type: "text",
        },
        {
          columns: columnsFailed,
          results: resultsFailed,
          sheetName: "Failed",
          type: "text",
        },
      ];
      exportExcelJs(alldata, excelName);
    },
    async exportExeclDownloadSingle(row){
      let params = [row.id];
      downloadFileByIds(params).then((res) => {
        if (res) {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement("a");
          link.href = url;
          link.download = "download.zip";
          link.click();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    exportExeclDownloadSingleOld(row) {
      let successCompanies = row.uploadCleaningResultList;
      // ===1. 生成 columns（将 "Company Name" 置顶）====
      let fields = [...successCompanies]; // 浅拷贝
      fields.sort((a, b) => {
        if (a.fieldDec === "Company Name") return -1;
        if (b.fieldDec === "Company Name") return 1;
        return 0;
      });
      const columns = fields.map((item) => ({
        header: item.fieldDec,
        key: item.fieldCode,
        width: 30,
      }));
      // ====2. 生成 result（单条数据对象）====
      const rowData = {};
      for (const item of successCompanies) {
        if (item.fieldCode !== undefined && item.fieldValue !== undefined) {
          rowData[item.fieldCode] = item.fieldValue;
        }
      }
      const result = [rowData]; // 包装成数组，保持和之前格式一致

      let excelName = row.companyName;
      let alldata = [
        {
          columns: columns,
          results: result,
          sheetName: "Success",
          type: "text",
        },
      ];
      exportExcelJs(alldata, excelName);
    },
    // adjust 回显当前展开的行
    async adjustDataCleaning(row, index) {
      console.log("Adjust的row", JSON.parse(JSON.stringify(row)));
      this.operationAdjust = true;
      this.handleExpandRowIndex = index;
      this.step = 3;
      this.fileUploading = true;
      this.fileUploadingSuccess = true;
      this.fileUploadingAllow = true;
      this.fileUploadingCurrentPercent = 100;
      this.fileUploadingResult.filesId = row.batchId;
      this.uploadFileDetail.name = row.fileName;
      this.uploadFileDetail.size = row.fileBytes
        ? await this.formatFileSize(row.fileBytes)
        : "-";
      this.step2checkList = await this.findListByBatchIdAndUserIdFn(
        row.batchId,
      );
      // this.uploadProgressRes.fileName = row.fileName;
      // this.uploadProgressRes.batchId = row.batchId;
      // this.uploadProgressRes.progressRatio = '100%';
      // this.uploadProgressRes.remainTime = '0s';
      this.$refs.deatCleaningContainer.scrollTo({
        top: 0,
        // behavior: 'smooth'
      });
    },
    async findListByBatchIdAndUserIdFn(id) {
      let res = await findListByBatchIdAndUserId(`?batchId=${id}`);
      let data = res.data || [];
      let arr = data.map((item) => item.fieldCode);
      return arr;
    },
    closeSelectfiledRefresh() {
      this.getChildrenData(this.subtableCleanParent);
    },
    // 单个 update
    updateDataCleaning(row, parentRow) {
      this.updateDataCleaningType = "single";
      this.subtableCleanParent = parentRow;
      this.aaaIdUpdate = [row.aaaId];
      this.aaaIdCompanyUpdate = [
        {
          companyName: row.companyName,
          aaaId: row.aaaId,
          country: row.companyCountry,
        },
      ];
      this.parentTaskId = parentRow.batchId;
      this.dialogVisibleUpdate = true;
    },
    // 批量
    batchUpdateDataCleaning(parentRow) {
      this.updateDataCleaningType = "batch";
      this.subtableCleanParent = parentRow;
      this.parentTaskId = parentRow.batchId;
      const aaaids = parentRow.selectedChildren.reduce((acc, item) => {
        if (item.aaaId) {
          acc.push(item.aaaId);
        }
        return acc;
      }, []);
      this.aaaIdUpdate = aaaids;
      const companys = parentRow.selectedChildren.map((item) => ({
        companyName: item.companyName,
        aaaId: item.aaaId,
        country: item.companyCountry,
      }));
      this.aaaIdCompanyUpdate = companys;
      this.dialogVisibleUpdate = true;
    },
    closeDialogVisibleUpdate() {
      this.dialogVisibleUpdate = false;
    },

    formatTaskStatus(status) {
      if (status == 2) {
        return "Cleaning";
      }
      const item = this.taskStatusOptions.find((item) => item.value == status);
      return item ? item.label : "";
    },
    formatTaskStatusClass(status) {
      if (status == 2) {
        return "progress";
      }
      const item = this.taskStatusOptions.find((item) => item.value == status);
      return item ? item.class : "";
    },
    formatCreateTime(val) {
      return val.replace("T", " ");
    },
    async getFilesListFn() {
      console.log('this.taskTagvalue', this.taskTagvalue, 'this.taskStatusvalue', this.taskStatusvalue);
      const rawParams = {
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
        fileName: this.fileNameValue,
        taskStatus: this.taskStatusvalue,
        enumValue: this.taskTagvalue && this.taskTagvalue.join(','),
        startTime: this.cleaningTimePicker && this.cleaningTimePicker[0],
        endTime: this.cleaningTimePicker && this.cleaningTimePicker[1],
      };
      // 核心逻辑：过滤掉值为 null, undefined, 或 空字符串 '' 的项
      const params = Object.fromEntries(
        Object.entries(rawParams).filter(([key, value]) => {
          // 判断条件：值存在 且 不是空字符串
          return value !== null && value !== undefined && value !== '';
        })
      );
      await getFilesList(params).then((res) => {
        console.log("4.查询已上传文件、状态等概要", res);
        const list = res.data.rows; 
        this.taskList = list.map(row => ({
          ...row, 
          inputVisible: false,
          inputValue: '',
          editingTagId: null
        }));
        this.page.total = res.data.total;
        this.expandedRowKeys = [];
      });
    },
    resetFilters() {
      this.fileNameValue = null;
      this.cleaningTimePicker = null;
      this.taskStatusvalue = null;
      this.taskTagvalue = null;
      this.getFilesListFn();
    },
    async toRegenerate() {
      this.reUploading();
      this.step2checkList = [];
      // let params = [
      //   {
      //       batchId: this.uploadProgressRes.batchId,
      //       filedCodes: this.step2checkList
      //   }
      // ];
      // await regenerate(params).then((res) => {
      //   console.log('Regenerate 结果', JSON.parse(JSON.stringify(res)));
      //   if(res.code == 200){
      //     this.getFilesListFn();
      //   }
      // });
    },

    async getStatisticsFn() {
      await getStatistics().then((res) => {
        this.statisticsRes = res.data;
      });
    },

    // 将存起来的定时器一并清除
    clearAllIntervalUploadProgress() {
      // this.cleaningLoading = false;
      this.loadingVisible = false;
      this.allTimers.map((item) => {
        clearInterval(item);
      });
    },
    fileSelectedStep() {
      this.step = 2;
    },
    step2Reselect() {
      this.step2checkList = [];
    },
    cleanOverCancel() {
      this.cleanOverVisible = false;
    },
    cleanOverConfirm() {
      // 保存标签
      // 1. 过滤空值
      const validValues = this.dcTagInputList.filter(item => item && item.trim() !== '');
      if (validValues.length === 0) {
        this.cleanOverVisible = false;
        this.expandCurrentRow();
        return;
      }
      let params = validValues.map(val => ({
        enumValue: val,
        batchId: this.uploadProgressRes.batchId
      }));
      this.insertEnumFn(params, 'dialog');
    },
    async insertEnumFn(params, type){
      await insertEnum(params).then(async (res) => {
        console.log(res);
        if(res.code == 200){
          await this.getFilesListFn();
          this.getAllEnumFn();
          if(type == 'dialog'){
            this.cleanOverVisible = false;
            await this.expandCurrentRow();
          }else if(type == 'table'){
            
          }
        }else {
          this.$message.error(res.msg);
        }
        
      });
    },
    async getAllEnumFn(){
      await getAllEnum().then((res) => {
        console.log(res);
        if(res.code == 200){
          this.dcFiltersTags = res.data;
        }
        
      });
    },
    async dataCleaningStep() {
      // ✅ 核心：按 fieldList 顺序输出选中项
      console.log(this.step2checkList);
      let step2checkListSort = this.cleanFieldAllVisible
        .filter((field) => this.step2checkList.includes(field.fieldCode))
        .map((field) => field.fieldCode);
      console.log("排序后手动选择的项", step2checkListSort);
      console.log("默认的选中项", this.defaultCheckedList);
      let params = {
        batchId: this.fileUploadingResult.filesId, //之前接口1返回的filesId
        fieldCodes: [...this.defaultCheckedList, ...step2checkListSort], //用户勾选的字段
      };
      console.log("数据清洗参数", params);
      // this.cleaningLoading = true;
      this.loadingVisible = true;
      await saveFiledsAndCleaning(params).then((res) => {
        console.log("数据清洗", res);
        if (res.code == 200) {
          this.step = 3;
          const timerId = setInterval(() => {
            //3.1清洗进度轮询
            this.getUploadProgressFn();
          }, 1000);
          this.allTimers.push(timerId);
          setTimeout(() => {
            this.clearAllIntervalUploadProgress();
          }, 300000);
          // 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
          this.$once("hook:beforeDestroy", () => {
            this.clearAllIntervalUploadProgress();
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    async getUploadProgressFn() {
      // let params = "?batchId=" + this.fileUploadingResult.filesId;
      let params = {
        batchId: this.fileUploadingResult.filesId,
      };
      await getUploadProgress(params).then(async (res) => {
        console.log("清洗进度轮询", res);
        if (res.code == 200) {
          this.uploadProgressRes = res.data;
          if (res.data.progressRatio == "100%") {
            this.loadingVisible = false;
            this.$message.success("Cleaning completed");
            this.clearAllIntervalUploadProgress();
            await this.getFilesListFn();
            this.getStatisticsFn();
            this.cleanOverVisible = true;
            this.dcTagInputList = [''];
          }
        } else {
          this.$message.error(res.msg);
          this.clearAllIntervalUploadProgress();
        }
      });
    },
    async getFindAllEnableFields() {
      let arrData = localStorage.getItem("dataCleaningField");
      if (arrData) {
        this.cleanFieldAll = JSON.parse(
          localStorage.getItem("dataCleaningField"),
        );
        return;
      }
      await findAllEnableFields().then((res) => {
        this.cleanFieldAll = res.data;
        localStorage.setItem("dataCleaningField", JSON.stringify(res.data));
      });
    },
    // 拖拽
    handleDragEnter(e) {
      console.log("文件进来了，要改变背景图了", e);
      e.preventDefault();
      e.stopPropagation();
      this.dragCounter++;
      if (this.dragCounter === 1) {
        this.isDragging = true;
        console.log("文件进入上传区域");
        // ✅ 在这里执行你的自定义操作（如高亮、日志等）
      }
    },
    handleDragOver(e) {
      e.preventDefault(); // 必须！否则 drop 事件不会触发
      e.stopPropagation();
    },
    handleDragLeave(e) {
      e.preventDefault();
      e.stopPropagation();
      this.dragCounter--;
      if (this.dragCounter === 0) {
        this.isDragging = false;
        console.log("文件离开上传区域");
        // ✅ 在这里执行恢复操作
      }
    },
    handleDrop(e) {
      e.preventDefault();
      e.stopPropagation();
      this.dragCounter = 0;
      this.isDragging = false;
      console.log("文件已放置，准备上传");
      // ✅ 在这里可以做额外处理（如校验、预览等）
      // 注意：Element Upload 会自动处理文件，你也可以手动获取 files:
      // const files = e.dataTransfer.files;
    },
    handleChange(file, fileList) {
      console.log("文件已选择:", file);
      this.uploadfileList = fileList;
    },
    toDetailView(row, list) {
      console.log("toDetailViewFn", row);
      this.showDetailView = true;
      // this.detailData = detail;
      let successList = list.filter(item => {
        const isSuccess = item.status === 1;
        const hasValidChildren = Array.isArray(item.uploadCleaningResultList) && item.uploadCleaningResultList.length > 0;
        return isSuccess && hasValidChildren;
      });
       // 2. 找到当前点击行在 successList 中的索引
      const index = successList.findIndex(item => item.id === row.id);
      this.uploadCleaningResultListIndex = index + 1;
      this.uploadCleaningResultList = successList;
    },
    showDetailViewBack() {
      this.showDetailView = false;
      // this.getFilesListFn();
    },
    getDifference(str) {
      if (!str || !str.includes("/")) return 0;
      const [right, total] = str.split("/");
      const r = Number(right),
        t = Number(total);
      return isNaN(r) || isNaN(t) ? 0 : t - r;
    },
    async handleExpandChange(row, expanded) {
      console.log(
        "展开的row",
        JSON.parse(JSON.stringify(row)),
        JSON.parse(JSON.stringify(expanded)),
        expanded.includes(row),
      );
      const isExpanded = expanded.some((r) => r.id === row.id);
      if (isExpanded && (!row.subData || row.subData.length === 0)) {
        console.log("第一次展开");
        // 添加筛选字段
        row.filterConame = "";
        row.filterLegalForm = "";
        row.filterCountry = "";
        row.filterStatus = "";
        row.filterDQI = "";
        await this.getChildrenData(row);
      } else {
        console.log("收起");
        this.$set(row, "selectedChildren", []);
      }
    },
    // Match 回显控制，回显当前展开的行
    async updateParentChildData(row, parentIndex){
      console.log(row, parentIndex);
      this.handleExpandRowIndex = parentIndex;
      await this.getFilesListFn();
      await this.expandCurrentRow();
    },
    // 展开的二级 table
    async getChildrenData(row) {
      console.log(row);
      let params = {
        batchId: row.batchId,
        companyName: row.filterConame,
        companyClass: row.filterLegalForm,
        country: row.filterCountry,
        itemStatus: row.filterStatus,
        dqi: row.filterDQI,
      };
      await getUploadedCompanies(params).then((res) => {
        console.log("展开的row的子table数据", JSON.parse(JSON.stringify(res)));
        if (res.data) {
          this.$set(row, "subData", JSON.parse(JSON.stringify(res.data)));
          // this.uploadCleaningResultList = res.data;
        }

        console.log("展开的row", JSON.parse(JSON.stringify(row)));
      });
      // 获取二级数据的筛选条件聚合，每次查都要调用
      await this.getUploadedCompaniesAggFn(row);
    },
    async expandCurrentRow() {
      if (this.taskList.length > 0) {
        const firstRow = this.handleExpandRowIndex ? this.taskList[this.handleExpandRowIndex] : this.taskList[0];
        // 设置只展开第一行
        this.expandedRowKeys = [firstRow.id];
        // 添加筛选字段
        firstRow.filterConame = "";
        firstRow.filterLegalForm = "";
        firstRow.filterCountry = "";
        firstRow.filterStatus = "";
        firstRow.filterDQI = "";
        await this.getChildrenData(firstRow);

        const container = this.$refs.deatCleaningContainer;
        const tableWrapper = this.$refs.Usagelist;
        if (container && tableWrapper) {
          // 获取容器和表格 wrapper 相对于视口的位置
          const containerRect = container.getBoundingClientRect();
          const tableRect = tableWrapper.$el.getBoundingClientRect();

          // 计算表格距离容器顶部的偏移（考虑容器自身的 scrollTop）
          const offsetTop =
            tableRect.top - containerRect.top + container.scrollTop;

          // 平滑滚动到该位置
          container.scrollTo({
            top: offsetTop,
            // behavior: 'smooth'
          });
          this.handleExpandRowIndex = null;
        }
      }
    },
    
    async getUploadedCompaniesAggFn(row) {
      let params = {
        batchId: row.batchId,
        companyName: row.filterConame,
        companyClass: row.filterLegalForm,
        country: row.filterCountry,
        itemStatus: row.filterStatus,
        dqi: row.filterDQI,
      };
      await getUploadedCompaniesAgg(params).then((res) => {
        console.log(
          "展开的row的子菜单筛选条件聚合",
          JSON.parse(JSON.stringify(res)),
        );
        if (res.code == 200) {
          this.$set(
            row,
            "filterCountryOptions",
            res.data[0].companyCountryAggregation,
          );
          this.$set(row, "filterStatusOptions", res.data[0].itemStatusAggregation);
          this.$set(row, "filterDQIOptions", res.data[0].qcScoreAggregation);
        }
      });
    },
    // 将子表格选中项保存到对应父行的 selectedChildren
    handleChildSelection(selection, parentRow) {
      // parentRow.selectedChildren = selection;
      this.$set(parentRow, "selectedChildren", selection);
      console.log(`[${parentRow.fileName}] 选中的子项:`, selection);
    },
    onPageChangeList({ page, size }) {
      this.page.pageSize = size;
      this.page.pageNo = page;
      this.getFilesListFn();
    },
    uploadTemplateDownload() {
      var a = document.createElement("a");
      a.href = "/dcUpload_template.xlsx";
      a.download = "Download template.xlsx";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    // 实时进度回调
    // 动画：从当前 progress 平滑到 100
    startProgress() {
      // 清除可能存在的旧定时器
      if (this.progressTimer) {
        clearInterval(this.progressTimer);
      }
      const start = this.fileUploadingCurrentPercent;
      const target = 100;
      const duration = 500; // 动画持续时间（毫秒）
      const startTime = Date.now();
      const animate = () => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(elapsed / duration, 1);
        // 使用线性插值：current = start + (target - start) * progress
        this.fileUploadingCurrentPercent = Math.round(
          start + (target - start) * progress,
        );

        if (progress < 1) {
          this.progressTimer = requestAnimationFrame(animate);
        } else {
          // 动画结束
          this.fileUploadingCurrentPercent = 100;
        }
      };
      animate();
    },
    fileUpload(params) {
      setTimeout(() => {
        if (this.fileUploadingAllow) {
          this.fileUploading = true;
          this.fileUploadingLoading = true;
          this.startProgress();
          console.log("fileUpload文件 params", params);
          const formData = new FormData();
          formData.append("file", params.file);
          dataCleaningUpload(formData).then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.fileUploadingLoading = false;
              this.fileUploadingResult = res.data;
              this.fileUploadingSuccess = true;
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      }, 1500);
    },

    async beforeUpload(file) {
      // 定义允许的扩展名
      this.fileUploadingAllow = false;
      this.fileUploading = true;
      const allowedTypes = ["xlsx", "xls", "csv"];
      // 获取文件扩展名（转小写）
      const extension = file.name.split(".").pop().toLowerCase();
      this.uploadFileDetail = {
        name: file.name,
        size: await this.formatFileSize(file.size),
      };
      // 检查是否在允许列表中
      if (!allowedTypes.includes(extension)) {
        console.log("阻止上传");
        setTimeout(() => {
          this.fileUploading = false;
          this.uploadfileList = [];
          this.$message.error("仅支持 xls、xlsx、csv 格式的文件！");
        }, 500);
        return false; // 阻止上传
      }
      // 校验文件大小（例如 ≤ 10MB）
      const maxSize = 100 * 1024 * 1024; // 100MB
      if (file.size > maxSize) {
        setTimeout(() => {
          this.fileUploading = false;
          this.uploadfileList = [];
          this.$message.error("文件大小不能超过 100MB！");
        }, 500);
        return false;
      }
      setTimeout(() => {
        this.fileUploadingAllow = true;
        return true; // ✅ 允许上传
      }, 500);
    },
    removeUploadFile() {
      this.uploadfileList = [];
      this.fileUploading = false;
      this.fileUploadingSuccess = false;
      // 如果你还需要清除 input 的值（防止同文件无法触发 change）
      if (this.$refs.dcUploadRef) {
        const input =
          this.$refs.dcUploadRef.$el.querySelector('input[type="file"]');
        if (input) input.value = "";
      }
    },
    async formatFileSize(bytes) {
      if (bytes >= 1024 * 1024) {
        // ≥1MB → 显示 MB
        return (bytes / (1024 * 1024)).toFixed(2) + " MB";
      } else if (bytes >= 1024) {
        // ≥1KB 且 <1MB → 显示 KB
        return (bytes / 1024).toFixed(1) + " KB";
      } else {
        // <1KB → 显示 bytes
        return bytes + " B";
      }
    },
    reUploading() {
      this.removeUploadFile();
      this.step = 1;
      this.uploadFileDetail = {
        name: "",
        size: 0,
      };
      this.uploadProgressRes = {
        fileName: "",
        batchId: "",
        progressRatio: "",
        remainTime: "",
        successCount: "",
        failedCount: "",
      };
      this.operationAdjust = false;
    },
    cancelUploading() {
      this.removeUploadFile();
      this.fileUploadingAllow = false;
    },
  },
};
</script>
<style scoped>
.deatCleaning-container {
  padding: 20px 20px 10px;
  overflow-y: auto;
}
.deatCleaning-inner {
}
.deatCleaning-steps {
  height: auto;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}
.deatCleaning-steps-title {
  padding: 30px 40px;
}
.deatCleaning-steps-title .small-title {
  height: 20px;
  font-family: ArialMT;
  font-size: 18px;
  color: #666666;
  line-height: 22px;
  text-align: left;
}
.deatCleaning-steps-title .big-title {
  height: 30px;
  font-family: Arial Bold;
  font-weight: bold;
  font-size: 22px;
  color: #1a2332;
  line-height: 30px;
  text-align: left;

  margin-bottom: 14px;
}
.deatCleaning-steps-box {
  display: flex;
  justify-content: center;
  gap: 0 20px;
  /* align-items: center; */
  padding: 0 20px 12px;
}
.deatCleaning-steps-con {
  /* width: 461px; */
  width: 25.5%;
  min-height: 540px;
  background: url("../../../assets/images/dc_step.png") no-repeat center/100%
    100%;
  padding: 26px 24px 34px;
  flex-shrink: 0;
  transition: all 0.1s;
}
.deatCleaning-steps-con-in {
  height: 100%;
  display: flex;
  flex-direction: column; /* 垂直排列 */
  justify-content: space-between; /* 上下两端对齐 */
  padding: 0 24px 30px;
}
.deatCleaning-steps-con.active {
  background-image: url("../../../assets/images/dc_step_active.png");
}
.deatCleaning-steps-con.active.dragbg {
  background-image: url("../../../assets/images/dc_step_activebg.png");
}
.deatCleaning-steps-arrow {
  width: 30px;
  /* height: 30px; */
  flex-shrink: 0;
}
.steps-con-title {
  height: 30px;
  font-weight: normal;
  font-size: 24px;
  color: #fff;
  line-height: 30px;
  text-align: center;
  font-family: Arial Bold;
  margin: 12px 0 36px;
}
.steps-con-subtitle {
  height: 48px;
  font-weight: normal;
  font-size: 22px;
  color: #1a2332;
  line-height: 24px;
  text-align: center;
  margin-bottom: 14px;
  /* white-space: nowrap; */
  font-family: Arial Bold;
}
.steps-con-smalltitle {
  font-size: 18px;
  color: #666666;
  line-height: 24px;
  text-align: left;
}
.deatCleaning-result {
  display: flex;
  margin: 10px 0;
}
/* 左边筛选 */
.deatService-left-filter {
  width: 330px;
  height: 500px;
  padding-right: 22px;
  position: relative;
  padding-top: 12px;
}
.deatService-left-filter .deatService-left-filter-reset {
  position: absolute;
  right: 40px;
  top: 30px;
  font-family: ArialMT;
  font-size: 16px;
  color: #1a2332;
  z-index: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.deatService-left-filter .deatService-left-filter-reset i {
  color: #b98b73;
  font-size: 20px;
  vertical-align: bottom;
}
.dataService-left-collapse .dataService-left-item{
  padding: 0 0 10px 30px;
}
.dataService-left-collapse /deep/ .el-input__suffix {
  right: 5px;
}
.dataService-left-collapse /deep/ .el-input__inner::placeholder,
.dataService-left-collapse /deep/ .el-range-input::placeholder {
  font-size: 16px !important;
  color: #666666 !important;
}
.dataService-left-collapse .dataService-left-header {
  height: 54px;
  line-height: 54px;
  position: relative !important;
  font-size: 16px;
  color: #1a2332;
  font-family: Arial Bold;
  border: 0;
}
.dataService-left-collapse .el-input,
.dataService-left-collapse .el-select,
.dataService-left-collapse .el-date-editor {
  width: 100%;
}
.dataService-left-collapse /deep/ .el-collapse-item__content .el-input__inner {
  border-radius: 4px;
}
.deatCleaning-table-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  transition: flex 0.3s;
  padding: 0 14px;
  margin: 0 -14px;
}
.deatCleaning-table-summary {
  /* height: 134px; */
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 29px 0;
  margin-bottom: 10px;
}
.deatCleaning-table-summary .summary-item {
  text-align: center;
  width: 25%;
  position: relative;
}
.deatCleaning-table-summary .summary-item:not(:last-child)::after {
  content: "";
  position: absolute;
  top: 50%; /* 从顶部 50% 开始 */
  right: 0; /* 调整到两个 item 中间（配合 gap 或 margin）*/
  transform: translateY(-50%); /* 向上移动自身高度的一半 → 居中 */
  width: 4px;
  height: 32px;
  background: #eeeeee;
  border-radius: 2px;
}
.summary-item .summary-item-num {
  font-family: Arial Bold;
  font-size: 28px;
  color: #b98b73;
  line-height: 26px;
  margin-bottom: 20px;
}
.summary-item .summary-item-num.totalTasks {
  color: #009ea7;
}
.summary-item .summary-item-num.tasksin30Days {
  color: #81c97a;
}
.summary-item .summary-item-num.completedTasks {
  color: #8e86dd;
}
.summary-item .summary-item-num.successRate {
  color: #ff7600;
}
.summary-item .summary-item-title {
  /* font-family: ArialMT; */
  font-size: 20px;
  color: #1a2332;
}
.deatCleaning-table-in {
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 21px 16px;
}
.custom-parent-table /deep/ .el-table__empty-block {
  background-image: url("../../../assets/images/dataServices/dataCleaning-img/nodata.png");
  margin: 40px 0 20px;
  min-height: 300px;
  background-size: contain;
}
.deatCleaning-table-in /deep/ th.el-table__cell {
  background: #f3f3f3;
  padding: 13px 0;
}
.deatCleaning-table-in /deep/ td.el-table__cell {
  height: auto;
  padding: 18px 0;
}
.deatCleaning-table-in /deep/ .cell {
  font-size: 16px !important;
  line-height: 30px !important;
}
.deatCleaning-table-in /deep/ .el-table__expand-icon {
  display: block !important;
}
.deatCleaning-table-in /deep/ .el-table__expand-icon .el-icon-arrow-right {
  left: 50%;
  top: 50%;
  margin: 0;
  right: auto;
  transform: translate(-50%, -50%) rotate(90deg);
}
.deatCleaning-table-in
  /deep/
  .el-table__expand-icon.el-table__expand-icon--expanded
  .el-icon-arrow-right {
  transform: translate(-50%, -50%) rotate(180deg);
}
.deatCleaning-table-in /deep/ .el-table__expanded-cell {
  background: #f0f0f0 !important;
  padding: 14px !important;
}
.deatCleaning-table-in /deep/ .el-table__expanded-cell:hover {
  background: #f0f0f0 !important;
}
.deatCleaning-table-in /deep/ .expanded td.el-table__cell {
  border-bottom: 0 !important;
}
.deatCleaning-table-in /deep/ .tree_table_box {
  padding: 0 !important;
}
.dataClean-operate {
  font-size: 16px;
  color: #b98b73;
  height: 15px;
  line-height: 15px;
  padding: 0 8px;
  white-space: nowrap;
  cursor: pointer;
  border-radius: 0;
  background: none!important;
  text-decoration: none!important;
  margin: 0 !important;
}
.dataClean-operate:not(:last-child) {
  border-right: 1px solid #d3d3d3;
}
.dataClean-operate:first-of-type {
  padding-left: 0;
}
.dataClean-operate:last-of-type {
  padding-right: 0;
}
.dataClean-operate.is-disabled {
  color: #dfcec5;
  background: none;
}

/* .deatCleaning-table-in /deep/ .tree_table_box th.el-table__cell{
  background: #F2F5F9 !important;
} */
.page_i_box.dataService {
  margin-top: 20px;
}

.point-taskStatus {
  width: 8px;
  height: 8px;
  background: #ccc;
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
  margin-right: 8px;
}
.point-taskStatus.mini {
  width: 6px;
  height: 6px;
}
.point-taskStatus.completed {
  background: #59e41f;
}
.point-taskStatus.progress {
  background: #22b3f5;
}
.point-taskStatus.regenerating {
  background: #ffa52d;
}
.point-taskStatus.cancelled {
  background: #ff4646;
}
.point-taskStatus.cleaningCompleted {
  background: #b98b73;
}
.dc-download-template {
  font-family: ArialMT;
  font-size: 18px;
  color: #b98b73;
  line-height: 26px;
  text-align: left;
  font-style: normal;
  text-decoration-line: underline;
  margin-left: 12px;
  cursor: pointer;
}
.dc-download-template-out {
  padding: 14px 0;
}

.dc-upload-start {
  text-align: center;
  margin-top: 22px;
  height: 188px;
  width: 100%;
  position: relative;
}
.dc-upload-start-tip {
  font-family: ArialMT;
  font-size: 16px;
  color: #666666;
  line-height: 26px;
}
.dc-upload-uploader {
  margin: 0 auto;
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.dc-upload-uploader /deep/ .el-upload {
  height: 100%;
  width: 100%;
}
.dc-upload-uploader .dc-upload-uploader-icon {
  width: auto;
  height: 42px;
}
.dc-upload-uploader /deep/ .el-upload-dragger {
  height: 100%;
  width: 100%;
  background: transparent;
  border: 0;
}
.upload-select-btn {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.dc-upload-ing {
  margin-top: 22px;
  height: 188px;
  width: 100%;
  position: relative;
}
.dc-upload-ing-inner {
  display: flex;
  align-items: flex-end;
}
.dc-upload-ing-icon {
  width: 66px;
  height: 60px;
  flex-shrink: 0;
}
.dc-upload-ing-file {
  flex: 1;
  min-width: 0;
}
.dc-file-ttile {
  font-size: 18px;
  color: #1a2332;
  line-height: 24px;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
  margin-bottom: 7px;
}
.dc-file-memory {
  font-size: 14px;
  color: #999999;
  line-height: 16px;
}
.dc-upload-ing-close {
  width: 20px;
  height: 20px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(221, 221, 221, 0.4);
  border: 1px solid #cccccc;
  border-radius: 50%;
  line-height: 18px;
  text-align: center;
  flex-shrink: 0;
  cursor: pointer;
}
.dc-upload-ing-close i {
  color: #1a2332;
  font-size: 12px;
}
.dc-upload-ing-progress {
  margin-top: 20px;
}
.dc-upload-ing-progress /deep/ .el-progress-bar__inner {
  background: #b98b73;
}
.dc-upload-ing-progress /deep/ .el-progress-bar {
  padding-right: 0;
  margin-right: 0;
}
.dc-upload-ing-progress /deep/ .el-progress__text {
  text-align: right;
  width: 100%;
  color: #b98b73 !important;
  font-size: 14px !important;
  line-height: 30px;
  margin-left: 0;
}
.dc-cleaning-ing-box {
  margin: 20px 0 0 0;
}
.dc-cleaning-ing-title {
  margin-bottom: 10px;
  display: flex;
}
.cleaning-ing-label,
.cleaning-ing-ellipsis {
  font-family: Arial Bold;
  font-size: 20px;
  color: #1a2332;
  line-height: 26px;
}
.cleaning-ing-ellipsis {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dc-cleaning-ing-smtitle {
  display: flex;
  margin-bottom: 10px;
}
.cleaning-ing-smtitle-fixed {
  font-size: 18px;
  color: #666666;
  line-height: 26px;
}
.cleaning-ing-smtitle-ellipsis {
  font-size: 18px;
  color: #666666;
  line-height: 26px;
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dc-cleaning-ing-timing {
  font-size: 18px;
  color: #d58242;
  line-height: 26px;
}
.dc-cleaning-ing-timing i {
  vertical-align: baseline;
}
.dc-cleaning-ing-progress {
  text-align: right;
  font-size: 14px;
  color: #1a2332;
  line-height: 24px;
}
.dc-cleaning-ing-progress .el-progress-bar__outer {
  background: transparent !important;
}
.deatCleaning-steps-btn {
  width: 160px;
  height: 36px;
  font-size: 18px;
}

.deatCleaning-steps-footer {
  width: 100%;
}
.steps-con-collapse {
  height: 200px;
  overflow-y: auto;
  padding: 10px 0;
}
.steps-con-collapse /deep/ .el-collapse {
  border: 0;
}
.steps-con-collapse /deep/ .el-collapse-item__header,
.steps-con-collapse /deep/ .el-collapse-item__wrap {
  background: transparent;
  font-size: 18px;
  color: #666;
  border: 0;
}
.steps-con-collapse-checkbox /deep/ .el-checkbox {
  display: block;
  margin-top: 10px;
}
.steps-con-collapse-checkbox /deep/ .el-checkbox__inner {
  border-color: #ccc;
  /* background: transparent; */
}
.steps-con-collapse-checkbox /deep/ .el-checkbox__label {
  font-size: 18px;
  color: #666;
  white-space: normal;
  vertical-align: top;
}
/* .steps-con-collapse-checkbox /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #B98B73;
  border-color: #B98B73;
}
.steps-con-collapse-checkbox /deep/ .el-checkbox__input.is-disabled .el-checkbox__inner {
  background-color: #edf2fc;
  border-color: #DCDFE6;
}
.steps-con-collapse-checkbox /deep/ .el-checkbox__input.is-checked.is-disabled .el-checkbox__inner {
  background-color: #DFCEC5;
  border-color: #DFCEC5;
} */
.dc-cleaning-timepicker /deep/ input:first-of-type {
  position: relative;
  left: -17px;
  text-align: left;
}
.dc-cleaning-timepicker /deep/ input:last-of-type {
  text-align: right;
}
.dc-cleaning-timepicker /deep/ .el-icon-date {
  left: 45%;
}
.dataCleaning-spinner {
  width: 25px;
  height: 25px;
  border: 3px solid #b98b73; /* 浅灰色背景 */
  border-bottom: 3px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
/* 扫描进度 */
.loading_box {
  width: 286px;
  height: 286px;
  overflow: hidden;
  position: relative;
  margin-top: 30px;
  margin-bottom: 10px;
  background-image: url("../../../assets/images/dataServices/dataCleaning-img/loadingOut_bg.png");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading_bg {
  margin: 0 auto;
  width: 192px;
  height: 192px;
  background-image: url("../../../assets/images/dataServices/dataCleaning-img/loadingCon_bg.png");
  background-size: cover;
  background-position: center;
  animation: spin 3s linear infinite;
}
.loading_num {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: bold;
  font-size: 40px;
  color: #ffffff;
  line-height: 80px;
  text-align: center;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.dataCleaning-result-succeccFailed {
  display: flex;
  gap: 0 10px;
}
.dataCleaning-result-succeccFailed .res-success {
  color: #59e41f;
  width: 50%;
}
.dataCleaning-result-succeccFailed .res-failed {
  color: #ff4646;
  width: 50%;
}
.content-result-title {
  font-size: 30px;
  color: #1a2332;
  line-height: 36px;
  text-align: center;
  font-weight: bold;
  margin-top: 20px;
}
.content-result-detail {
  font-size: 20px;
  color: #1a2332;
  line-height: 30px;
  margin: 20px 0 16px;
  word-break: break-word;
}
.content-result-detail .txt-brown {
  color: #b98b73;
}
.content-result-detail .txt-green {
  color: #02815c;
}
.content-result-detail .txt-red {
  color: #f55656;
}

.dc-cleaning-btn {
  width: 234px;
  height: 52px;
  background: #b98b73;
  border-radius: 10px;
  font-size: 20px;
  color: #ffffff;
}
.dc-cleaning-btn-reset {
  width: 234px;
  height: 52px;
  border-radius: 10px;
  border: 1px solid #b98b73;
  font-size: 20px;
  color: #b98b73;
}
.datacleaningFinal.dialog_modal /deep/ .el-dialog__body{
  overflow: unset;
}
.datacleaning-tags-title{
  font-size: 20px;
  color: #1A2332;
  line-height: 30px;
  margin-bottom: 14px;
}
.datacleaning-tags-wrapper{
  margin-bottom: 18px;
}
.datacleaning-tags-wrapper .el-input{
  height: 68px;
  font-size: 20px;
}
.datacleaning-tags-wrapper /deep/ .el-input__suffix{
  right: 20px;
}
.datacleaning-tags-wrapper /deep/ .el-input .el-input__suffix-inner i{
  font-weight: bold;
  color: #B98B73;
  font-size: 18px;
  cursor: pointer;
}
.datacleaning-tags-wrapper /deep/ .el-input__inner::placeholder{
  font-size: 20px;
  color: #999999;
} 
.filter-tag{
  height: 30px;
  line-height: 30px;
  background: #F5F5F5;
  border-radius: 6px 6px 6px 6px;
  border-color: transparent;
  color: #1A2332;
  cursor: pointer;
  /* 关键：固定基准宽度为 1/3，减去 gap 的补偿 */
  /* flex: 1;  */
  /* 必须设置，防止内容把 tag 撑大破坏均分 */
  min-width: 0; 
  max-width: 100%; 
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 16px;
}
.filter-tag /deep/ .el-icon-close{
  color: #1A2332;
  font-size: 18px;
}
.filter-tag:hover{
  border-color: #B98B73;
  background: #FAF1EC;
}
.filter-tag:hover /deep/ .el-icon-close{
  color: #B98B73;
}
.filter-tag /deep/ .el-tag__close:hover{
  background-color: transparent;
}
.filter-tag-text{
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.filter-tag-row{
  display: flex;
  align-items: center;
  width: 100%;
  gap: 4px;
}
.filter-tag-list{
  flex: 1;
  display: flex;
  gap: 4px;
  min-width: 0;
  overflow: hidden;
}
.filter-tag-btn{
  flex: 0 0 104px;
  width: 104px;
  display: flex;
  justify-content: flex-end;
}
.button-new-tag{
  width: 104px;
  height: 32px;
  flex-shrink: 0;
  background: #FAF1EC;
  border-radius: 6px;
  font-size: 16px;
  color: #B98B73;
  line-height: 32px;
  padding: 0 10px;
}

.filter-tag-row .input-new-tag {
  background: #FAF1EC;
  padding: 4px;
  border-radius: 6px;
  line-height: 24px;
}
.filter-tag-row .input-new-tag /deep/ .el-input__inner{
  border: 1px solid #B98B73;
  height: 24px;
  line-height: 24px;
  border-radius: 6px;
}
/* 媒体查询-统一化 */
/* 大中版本：media的范围（1920px至1440px） */
/* 小版本：media的范围（1440px至1280px） */
@media (max-width: 1920px) {
  /* 标题字体 20px */
  .deatCleaning-steps-title .big-title,
  .steps-con-subtitle,
  .summary-item .summary-item-title{
    font-size: 20px !important;
  }
  /* 文本字体 16px */
  .dataServices-page,
  .deatCleaning-steps-title .small-title,
  .dc-download-template,
  .steps-con-smalltitle,
  .dc-upload-start-tip,
  .deatCleaning-steps-btn,
  .steps-con-collapse-checkbox /deep/ .el-checkbox__label,
  .dc-download-template,
  .dataService-left-collapse .dataService-left-header,
  .dataService-left-collapse /deep/ .el-input__inner::placeholder,
  .dataService-left-collapse /deep/ .el-range-input::placeholder,
  .deatCleaning-table-in /deep/ .cell,
  .datacleaning-tags-wrapper /deep/ .el-input__inner::placeholder,
  .dataClean-operate,
  .filter-tag,
  .button-new-tag,
  .deatService-left-filter .deatService-left-filter-reset,
  .dc-file-ttile,
  .cleaning-ing-smtitle-fixed,
  .cleaning-ing-smtitle-ellipsis
  {
    font-size: 16px !important;
  }
  
  /* 圆角 */
  .deatCleaning-steps, 
  .deatCleaning-table-summary,
  .deatCleaning-table-in{
    border-radius: 10px;
  }
  /* 表格 */
  .deatCleaning-table-in /deep/ thead {
    height: auto !important;
  }
  .deatCleaning-table-in /deep/ th.el-table__cell,
  .deatCleaning-table-in /deep/ .has-gutter .el-table__cell {
    height: auto !important;
    padding: 7px 0;
  }
  .deatCleaning-table-in /deep/ td.el-table__cell {
    padding: 9px 0;
  }
  /* padding + margin  */
  .deatCleaning-container{
    padding: 15px 15px 8px;
  }
  .deatCleaning-table-box{
    padding: 0 15px;
    margin: 0px -15px;
  }
  .deatCleaning-steps-title{
    padding: 22px 30px;
  }
  .deatCleaning-steps-con{
    /* padding: 28px 18px 26px; */
  }
  .deatCleaning-table-summary{
    padding: 22px 0;
  }
  .deatCleaning-table-in{
    padding: 16px 12px;
  }
  .dataService-left-collapse .dataService-left-item{
    padding: 0 0 8px 22px;
  }
  .deatCleaning-steps-title .big-title{
    margin-bottom: 10px;
  }
  /* form 表单 */
  .dataService-left-collapse /deep/ .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
  /* 其他 */
  .dc-upload-uploader .dc-upload-uploader-icon {
    height: 32px;
  }
}
@media (max-width: 1440px) {
  /* 标题字体 18px */
  .deatCleaning-steps-title .big-title,
  .steps-con-subtitle,
  .summary-item .summary-item-title{
    font-size: 18px !important;
  }
  /* 文本字体 14px */
  .dataServices-page,
  .deatCleaning-steps-title .small-title,
  .dc-download-template,
  .steps-con-smalltitle,
  .dc-upload-start-tip,
  .deatCleaning-steps-btn,
  .steps-con-collapse-checkbox /deep/ .el-checkbox__label,
  .dc-download-template,
  .dataService-left-collapse .dataService-left-header,
  .dataService-left-collapse /deep/ .el-input__inner::placeholder,
  .dataService-left-collapse /deep/ .el-range-input::placeholder,
  .deatCleaning-table-in /deep/ .cell,
  .datacleaning-tags-wrapper /deep/ .el-input__inner::placeholder,
  .dataClean-operate,
  .filter-tag,
  .button-new-tag,
  .deatService-left-filter .deatService-left-filter-reset,
  .dc-file-ttile,
  .cleaning-ing-smtitle-fixed,
  .cleaning-ing-smtitle-ellipsis
  {
    font-size: 14px !important;
  }
  .deatService-left-filter .deatService-left-filter-reset i
  {
    font-size: 18px !important;
  }
  /* 圆角 */
  .deatCleaning-steps,
  .deatCleaning-table-summary,
  .deatCleaning-table-in{
    border-radius: 8px;
  }
  /* 表格 */
  .deatCleaning-table-in /deep/ thead {
    height: auto !important;
  }
  .deatCleaning-table-in /deep/ th.el-table__cell,
  .deatCleaning-table-in /deep/ .has-gutter .el-table__cell {
    height: auto !important;
    padding: 5px 0;
  }
  .deatCleaning-table-in /deep/ td.el-table__cell {
    padding: 6px 0;
  }
  /* padding + margin  */
  .deatCleaning-container{
    padding: 13px 13px 6px;
  }
  .deatCleaning-table-box{
    padding: 0 13px;
    margin: 0px -13px;
  }
  .deatCleaning-steps-title{
    padding: 20px 26px;
  }
  .deatCleaning-steps-con {
    width: 30%;
    /* padding: 26px 16px 22px; */
  }
  .deatCleaning-table-summary{
    padding: 20px 0;
  }
  .deatCleaning-table-in{
    padding: 14px 10px;
  }
  .dataService-left-collapse .dataService-left-item{
    padding: 0 0 6px 20px;
  }
  .deatCleaning-steps-title .big-title{
    margin-bottom: 9px;
  }
  /* form 表单 */
  .dataService-left-collapse /deep/ .el-input__inner {
    height: 28px;
    line-height: 28px;
  }
  /* 其他 */
  .dc-upload-uploader .dc-upload-uploader-icon {
    height: 28px;
  }
  
  /* 之前的  */
  .deatService-left-filter {
    width: 270px;
  }
  .deatCleaning-table-summary {
    padding: 19px 0;
  }
  .summary-item .summary-item-num {
    font-size: 24px;
    margin-bottom: 10px;
  }
  .summary-item .summary-item-title {
    font-size: 16px;
  }
  .deatCleaning-steps-box {
    gap: 0;
  }
  
  .deatCleaning-steps-con-in {
    padding: 0 18px 30px;
  }
  .steps-con-subtitle {
    font-size: 18px;
    line-height: 20px;
  }
  .steps-con-smalltitle {
    font-size: 14px;
    line-height: 20px;
  }
  
  .dc-download-template-out > img {
    height: 24px;
  }
  .steps-con-title {
    font-size: 20px;
  }
  
}
/* @media (max-width: 1700px) {
  .deatService-left-filter {
    width: 300px;
  }
  .summary-item .summary-item-num {
    font-size: 26px;
    margin-bottom: 14px;
  }
  .summary-item .summary-item-title {
    font-size: 18px;
  }
  .deatCleaning-steps-box {
    gap: 0 10px;
  }
  .deatCleaning-steps-con {
    width: 28%;
  }
  .steps-con-subtitle {
    font-size: 20px;
    line-height: 22px;
  }
  .steps-con-smalltitle {
    font-size: 16px;
    line-height: 22px;
  }
  .steps-con-collapse-checkbox /deep/ .el-checkbox__label {
    font-size: 16px;
  }
  .dc-download-template {
    font-size: 16px;
  }
  .dc-download-template-out > img {
    height: 28px;
  }
  .dc-upload-start-tip {
    font-size: 14px;
  }
  .deatCleaning-steps-btn {
    font-size: 16px;
  }
  .steps-con-title {
    font-size: 22px;
  }
} */



</style>

